import Text from 'src/components/Text';
import { PRIMARY_BLACK, STATUS_LABEL_ARCHIVED } from 'src/global/theme/colors';

import { styles } from './styles';

interface Props {
  operationError?: string;
  originalErrorCode?: string;
}

const TransactionOperationError = ({ operationError, originalErrorCode }: Props) => {
  const { classes } = styles();
  if (!operationError && !originalErrorCode) {
    return null;
  }
  return (
    <div className={classes.operationError}>
      {operationError && (
        <div className={classes.divider}>
          <Text variant="Caption-Regular" color={STATUS_LABEL_ARCHIVED}>
            Código de error de MODO
          </Text>
          <Text variant="Callout-Regular" color={PRIMARY_BLACK}>
            {operationError}
          </Text>
        </div>
      )}
      {originalErrorCode && (
        <div className={classes.divider}>
          <Text variant="Caption-Regular" color={STATUS_LABEL_ARCHIVED}>
            Código de error original
          </Text>
          <Text variant="Callout-Regular" color={PRIMARY_BLACK}>
            {originalErrorCode}
          </Text>
        </div>
      )}
    </div>
  );
};

export default TransactionOperationError;
